function ctgAndDegree(x) {
  return 1 / Math.tan(Number(x) * (Math.PI / 180.0));
}

export function berechneGewichtkraftDesAngehaengtenBodens(
  anzahlPfaehle,
  groesseresPfahlraster,
  kleineresPfahlraster,
  pfahllaenge,
  reibungswinkelBoden,
  anpassungsfaktor,
  wichteBoden
) {
  return (
    Number(anzahlPfaehle) *
    Number(groesseresPfahlraster) *
    Number(kleineresPfahlraster) *
    (Number(pfahllaenge) -
      (1 / 3) *
        Math.sqrt(
          Math.pow(Number(groesseresPfahlraster), 2) + Math.pow(Number(kleineresPfahlraster), 2)
        ) *
        ctgAndDegree(Number(reibungswinkelBoden))) *
    Number(anpassungsfaktor) *
    Number(wichteBoden)
  );
}

export function berechneLreq(
  BSP,
  Gdst,
  Qdst,
  Gstb,
  kleineresPfahlraster,
  groesseresPfahlraster,
  wichteBoden,
  anpassungsfaktor,
  anzahlPfaehle,
  reibungswinkelBoden
) {
  return (
    (Number(Gdst) * BSP.YGD + Number(Qdst) * BSP.YQD - Gstb * BSP.YGS) /
      (BSP.YGS *
        (Number(groesseresPfahlraster) *
          Number(kleineresPfahlraster) *
          Number(wichteBoden) *
          Number(anpassungsfaktor) *
          Number(anzahlPfaehle))) +
    (1 / 3) *
      (Math.sqrt(
        Math.pow(Number(groesseresPfahlraster), 2) + Math.pow(Number(kleineresPfahlraster), 2)
      ) *
        ctgAndDegree(Number(reibungswinkelBoden)))
  );
}

export function berechneLeft(Gdst, BSP, Qdst) {
  return (Number(Gdst) ?? 0) * BSP?.YGD + (Number(Qdst) ?? 0) * BSP?.YQD;
}

export function berechneRight(Gstb, BSP, gewichtkraftDesAngehaengtenBodens) {
  return gewichtkraftDesAngehaengtenBodens * BSP?.YGS + (Number(Gstb) ?? 0) * BSP?.YGS;
}
